import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import { GroupHeader } from '@bonniernews/dn-design-system-web/components/group-header/group-header.tsx'

import { LinkBoxItem, LinkBoxItemProps } from './link-box-item'

interface LinkBoxProps extends SharedProps {
  /** Array with link objects. Ex. [ { label: 'Sverige runt', text: '42 avsnitt', link: '#', mediaHtml: "", layout: 'quiz', attributes: { "data-test": "list-item-test-data" } } ] */
  linkBoxItems: LinkBoxItemProps[]
  /** Heading of the link box */
  vignetteText?: string
  /** Target URL for the header */
  vignetteTargetUrl?: string
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/link-box](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/link-box)
 * - Storybook: [LinkBox](https://designsystem.dn.se/?path=/docs/section-linkbox--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/link-box/link-box.scss'`
 */
export const LinkBox = ({
  linkBoxItems,
  vignetteText,
  vignetteTargetUrl,
  classNames,
  attributes = {},
}: LinkBoxProps) => {
  const componentClassName = 'ds-link-box'

  const classes = formatClassString([componentClassName, classNames])

  return (
    <div className={classes} {...attributes}>
      {vignetteText && <GroupHeader title={vignetteText} href={vignetteTargetUrl} />}
      <div className={`${componentClassName}__grid`}>
        {linkBoxItems.map((item, index) => (
          <LinkBoxItem {...item} key={index} />
        ))}
      </div>
    </div>
  )
}
